import React from 'react';

// Types
import { AiToolkitType, AiToolkitTypeSlugs } from './types';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Components
import { WpBadge } from 'Wpds/components/badge';

export const AiToolkitOptions: AiToolkitType[] = [
  {
    slug: AiToolkitTypeSlugs.updateAi,
    title: 'UpdateAI',
    description: 'Generate status updates with a few clicks to share with your team.',
    buttonText: 'Generate Summary',
    image: 'https://piprodperformassets.blob.core.windows.net/assets/charma_weekly_update_ai.png',
    to: PageUrlsConstants.UPDATE_AI_PAGE,
    badge: (
      <WpBadge color="yellow" variant="bold">
        Beta
      </WpBadge>
    ),
  },
  {
    slug: AiToolkitTypeSlugs.agendaAi,
    title: 'AgendaAI',
    description: 'AgendaAI automatically generates an agenda for any meeting when you connect it to Slack.',
    buttonText: 'Learn More',
    to: 'https://www.predictiveindex.com/software/perform/',
    image: 'https://piprodperformassets.blob.core.windows.net/assets/agenda-ai.png',
  },
  {
    slug: AiToolkitTypeSlugs.feedbackAi,
    title: 'FeedbackAI',
    description: 'Give constructive feedback in minutes with the help of AI.',
    buttonText: 'Give Feedback',
    image: 'https://piprodperformassets.blob.core.windows.net/assets/charma-feedback-ai.png',
  },
  {
    slug: AiToolkitTypeSlugs.threeSixtyReviews,
    title: '360 Feedback',
    description: 'Kick off 360 feedback that guides the team to create thoughtful feedback.',
    buttonText: 'Kickoff 360s',
    image: 'https://piprodperformassets.blob.core.windows.net/assets/charma-three-sixtys.png',
    to: PageUrlsConstants.COACHING_360_START,
    managerOnly: true,
  },
  {
    slug: AiToolkitTypeSlugs.performaceReviews,
    title: 'Performance Reviews',
    description: 'Manage performance reviews in one place while guiding managers to write meaningful reviews.',
    buttonText: 'Join Waitlist',
    image: 'https://piprodperformassets.blob.core.windows.net/assets/charma_float_grow.png',
    waitList: true,
    badge: (
      <WpBadge color="blue" variant="bold">
        Coming Soon!
      </WpBadge>
    ),
  },
  {
    slug: AiToolkitTypeSlugs.performanceImprovementPlan,
    title: 'Performance Improvement Plan',
    description: 'Create customized PIPs in a few easy steps.',
    buttonText: 'Join Waitlist',
    image: 'https://piprodperformassets.blob.core.windows.net/assets/charmie-team-pyramid.png',
    waitList: true,
    badge: (
      <WpBadge color="blue" variant="bold">
        Coming Soon!
      </WpBadge>
    ),
  },
  {
    slug: AiToolkitTypeSlugs.careerDevelopmentPlan,
    title: 'Career Development Plan',
    description: 'Collaborate on customized career development plans with your report.',
    buttonText: 'Join Waitlist',
    image: 'https://piprodperformassets.blob.core.windows.net/assets/charma_thumbs_u-.png',
    waitList: true,
    badge: (
      <WpBadge color="blue" variant="bold">
        Coming Soon!
      </WpBadge>
    ),
  },
  {
    slug: AiToolkitTypeSlugs.meetingNotes,
    title: 'Meeting Notes',
    description: 'Use AI to take notes for you during meetings.',
    buttonText: 'Join Waitlist',
    image: 'https://piprodperformassets.blob.core.windows.net/assets/charma_meeting_notes.png',
    waitList: true,
    badge: (
      <WpBadge color="blue" variant="bold">
        Coming Soon!
      </WpBadge>
    ),
  },
];
